/*!
 * Developed by Markant
 */
/**
 * Parses given filter into a string and concatenates it with the passed concatenation char
 * @param filter the filter to parse
 * @param concat concatenation char; default: ' '
 * @param encodeSpecialChars if set to true it will transform special character to their corresponding hex values (https://www.the-art-of-web.com/html/character-codes/)
 */
function filterAsText(filter, concat = ' ', encodeSpecialChars = false) {
    var _a;
    const { category, value } = filter;
    const categoryRepresentation = (category === null || category === void 0 ? void 0 : category.representation) ? category === null || category === void 0 ? void 0 : category.representation : category === null || category === void 0 ? void 0 : category.value;
    const parsedCategory = (_a = categoryRepresentation === null || categoryRepresentation === void 0 ? void 0 : categoryRepresentation.replace(' ', concat)) !== null && _a !== void 0 ? _a : '';
    const parsedValue = value.replace(' ', concat);
    const result = `${parsedCategory}${concat}${parsedValue}`;
    return encodeSpecialChars ? encodeURIComponent(result).replace(/%/g, '') : result;
}
/**
 * Checks whether 2 filters are the same.
 * @param filterA
 * @param filterB
 */
function isFilterEqual(filterA, filterB) {
    var _a, _b;
    return ((_a = filterA.category) === null || _a === void 0 ? void 0 : _a.value) === ((_b = filterB.category) === null || _b === void 0 ? void 0 : _b.value) && filterA.value === filterB.value;
}
/**
 * Returns the valid representation value for a `MarkantFilterCategory` or `MarkantFilter`.
 * @param value
 */
function representValue(value) {
    return value.representation || value.value;
}

export { filterAsText as f, isFilterEqual as i, representValue as r };
